module.exports = __webpack_public_path__ + "static/media/EXERGUECHAP4.f66e30e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/EXERGUECHAP4.png
// module id = 253
// module chunks = 0